import React from "react";
import json from "./posts.json";

import "../../blog.css";
import PostContent from "./postContent";
import { Link } from "react-router-dom";

const Blog: React.FC = () => {
  const posts = [...(json as PostContent[])].reverse(); // copy, then reverse

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "0 auto",
        marginTop: "1rem",
        padding: "0 2rem",
        font: "system-ui, 'Helvetica', sans-serif",
        color: "#555",
      }}
      className="blog"
    >
      <h1 style={{ textAlign: "center" }}>My Food Blog</h1>
      <p className="m-auto max-w-lg text-center">
        Hey there! I am here to try what is (hopefully) the best food out there,
        and document what I find!
      </p>
      <div className="m-auto text-center my-2">
        {posts.map((postData: PostContent) => (
          <Link key={postData.hash} to={postData.hash} className="text-lg">
            {postData.title} <br />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;
